class GoogleAnalytics {
	constructor() {}

	goal(goal) {
		let dataLayer = window.dataLayer || [];

		dataLayer.push({
			'eCategory': goal,
			'eAction': 'sentForm',
			'event': 'GTMForms'
		});

		console.log(`gt goal: ${goal}`);
	}
}

export default GoogleAnalytics;
